var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfirmIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 54,
    r: 52,
    stroke: "#229986",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.5405 60.453L57.7178 65.6303L88.758 34.5898L93.9438 39.7752L57.7178 76.0011L34.3832 52.6664L39.5686 47.481L47.3595 55.272L52.5405 60.453ZM52.5467 50.0847L70.7063 31.9248L75.8774 37.0958L57.7178 55.2555L52.5467 50.0847ZM42.1821 70.8201L37.001 76.0011L13.6665 52.6664L18.8519 47.481L24.033 52.6624L24.0287 52.6664L42.1821 70.8201Z",
    fill: "#229986"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmIcon);
export default __webpack_public_path__ + "static/media/Confirm_icon.49c24aa58795d89acb83e4ad1331e327.svg";
export { ForwardRef as ReactComponent };